import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { getSession } from "../utils/session"; // <--- IMPORTANTE
import { API_URL } from "../services/api";
import "./UserManager.css";

const OBJETIVOS = { bajar: "Bajar peso", subir: "Subir peso" };

const NUEVO = { firstName: "", lastName: "", email: "", password: "", phone: "", weight: "", height: "", goal: "" };

// `rutinas` (userId -> fecha) marca quién tiene rutina en la lista de Rutinas
function UserManager({ onSelectUser, showOnlyList, rutinas }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [nuevo, setNuevo] = useState(null); // datos del formulario de alta, null = cerrado
  const [creando, setCreando] = useState(false);
  const [errNuevo, setErrNuevo] = useState("");
  const [visto, setVisto] = useState(null); // id del usuario con los datos desplegados

  const campo = (k) => ({ value: nuevo[k], onChange: (e) => setNuevo({ ...nuevo, [k]: e.target.value }) });

  const handleCreate = async (e) => {
    e.preventDefault();
    setCreando(true);
    setErrNuevo("");
    try {
      const { token } = await getSession();
      await axios.post(`${API_URL}/admin/users`, nuevo, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setNuevo(null);
      fetchUsers();
    } catch (error) {
      setErrNuevo(error.response?.data?.error || "No se pudo crear el usuario.");
    }
    setCreando(false);
  };

  const fetchUsers = async () => {
    setLoading(true);
    setErr("");
    try {
      const { token } = await getSession();
      const res = await axios.get(`${API_URL}/admin/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(res.data.users || res.data); // Según tu backend
    } catch (error) {
      setErr("Error al obtener usuarios.");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleApprove = async (id) => {
    if (!window.confirm("¿Aprobar este usuario?")) return;
    try {
      const { token } = await getSession();
      await axios.put(
        `${API_URL}/users/admin/approve/${id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchUsers();
    } catch (err) {
      alert("Error al aprobar usuario.");
    }
  };

  const handleSuspend = async (id) => {
    if (!window.confirm("¿Suspender este usuario?")) return;
    try {
      const { token } = await getSession();
      await axios.put(
        `${API_URL}/users/admin/suspend/${id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchUsers();
    } catch (err) {
      alert("Error al suspender usuario.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar este usuario? Esta acción no se puede deshacer.")) return;
    try {
      const { token } = await getSession();
      await axios.delete(
        `${API_URL}/users/admin/delete/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchUsers();
    } catch (err) {
      alert("Error al eliminar usuario.");
    }
  };

  if (loading) return <div>Cargando usuarios...</div>;
  if (err) return <div style={{ color: "red" }}>{err}</div>;

  const estado = (u) =>
    u.approved
      ? { texto: "Aprobado", clase: "ok" }
      : u.suspended
      ? { texto: "Suspendido", clase: "mal" }
      : { texto: "Pendiente", clase: "espera" };

  // Para asignar rutinas sólo cuentan los clientes
  const lista = onSelectUser ? users.filter((u) => u.role !== "admin") : users;

  return (
    <div className="usuarios">
      {!showOnlyList &&
        (nuevo ? (
          <form className="app-card usuario-nuevo" onSubmit={handleCreate}>
            <h3>Nuevo usuario</h3>
            <p className="app-sub">Se crea ya aprobado. Pásale el correo y la contraseña para que entre.</p>
            {errNuevo && <div className="form-error">{errNuevo}</div>}
            <div className="usuario-nuevo-campos">
              <div className="form-group">
                <label htmlFor="nu-nombre">Nombre *</label>
                <input id="nu-nombre" className="app-input" required {...campo("firstName")} />
              </div>
              <div className="form-group">
                <label htmlFor="nu-apellidos">Apellidos</label>
                <input id="nu-apellidos" className="app-input" {...campo("lastName")} />
              </div>
              <div className="form-group">
                <label htmlFor="nu-email">Correo *</label>
                <input id="nu-email" type="email" className="app-input" required autoComplete="off" {...campo("email")} />
              </div>
              <div className="form-group">
                <label htmlFor="nu-pass">Contraseña * (mín. 6)</label>
                <input id="nu-pass" type="text" className="app-input" required minLength={6} autoComplete="new-password" {...campo("password")} />
              </div>
              <div className="form-group">
                <label htmlFor="nu-tel">Teléfono</label>
                <input id="nu-tel" type="tel" className="app-input" {...campo("phone")} />
              </div>
              <div className="form-group">
                <label htmlFor="nu-objetivo">Objetivo</label>
                <select id="nu-objetivo" className="app-input" {...campo("goal")}>
                  <option value="">Sin indicar</option>
                  <option value="bajar">Bajar peso</option>
                  <option value="subir">Subir peso</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="nu-peso">Peso (kg)</label>
                <input id="nu-peso" type="number" min="1" step="0.1" className="app-input" {...campo("weight")} />
              </div>
              <div className="form-group">
                <label htmlFor="nu-altura">Altura (cm)</label>
                <input id="nu-altura" type="number" min="1" className="app-input" {...campo("height")} />
              </div>
            </div>
            <div className="usuario-acciones">
              <button type="submit" className="app-btn app-btn-sm" disabled={creando}>
                {creando ? "Creando…" : "Crear usuario"}
              </button>
              <button type="button" className="app-btn app-btn-quiet app-btn-sm" onClick={() => setNuevo(null)}>
                Cancelar
              </button>
            </div>
          </form>
        ) : (
          <div>
            <button className="app-btn app-btn-sm" onClick={() => { setErrNuevo(""); setNuevo(NUEVO); }}>
              + Nuevo usuario
            </button>
          </div>
        ))}
      {lista.length === 0 && <div className="app-estado">No hay usuarios registrados.</div>}
      {lista.map((u, i) => {
        const e = estado(u);
        const id = u._id || u.uid;
        const abierto = visto === id;
        return (
          <article key={u._id || u.uid} className="usuario" style={{ "--d": `${i * 40}ms` }}>
            <div className="usuario-datos">
              <div className="usuario-nombre">
                {u.firstName} {u.lastName}
                {u.role === "admin" && <span className="app-etiqueta">Admin</span>}
                {rutinas?.has(u._id) && (
                  <span className="app-etiqueta">
                    Rutina · {new Date(rutinas.get(u._id)).toLocaleDateString("es-ES")}
                  </span>
                )}
              </div>
              <div className="usuario-email">{u.email}</div>
            </div>
            <span className={`usuario-estado usuario-estado-${e.clase}`}>{e.texto}</span>

            {abierto && (
              <dl className="usuario-ficha" id={`ficha-${id}`}>
                <div><dt>Teléfono</dt><dd>{u.phone || "—"}</dd></div>
                <div><dt>Ubicación</dt><dd>{u.location || "—"}</dd></div>
                <div><dt>Peso</dt><dd>{u.weight ? `${u.weight} kg` : "—"}</dd></div>
                <div><dt>Altura</dt><dd>{u.height ? `${u.height} cm` : "—"}</dd></div>
                <div><dt>Objetivo</dt><dd>{OBJETIVOS[u.goal] || "—"}</dd></div>
                <div><dt>Plan nutricional</dt><dd>{u.planNutricional ? "Asignado" : "Sin asignar"}</dd></div>
                <div><dt>Alta</dt><dd>{u.createdAt ? new Date(u.createdAt).toLocaleDateString("es-ES") : "—"}</dd></div>
              </dl>
            )}

            <div className="usuario-acciones">
              <button
                className="app-btn app-btn-quiet app-btn-sm"
                onClick={() => setVisto(abierto ? null : id)}
                aria-expanded={abierto}
                aria-controls={`ficha-${id}`}
                aria-label={abierto ? "Ocultar datos" : "Ver datos"}
                title={abierto ? "Ocultar datos" : "Ver datos"}
              >
                {abierto ? <FiEyeOff aria-hidden="true" /> : <FiEye aria-hidden="true" />}
              </button>
              {onSelectUser && showOnlyList && (
                <button className="app-btn app-btn-sm" onClick={() => onSelectUser(u)}>
                  {rutinas?.has(u._id) ? "Editar rutina" : "Crear rutina"}
                </button>
              )}
              {!showOnlyList && (
                <>
                  {!u.approved && (
                    <button className="app-btn app-btn-sm" onClick={() => handleApprove(u._id || u.uid)}>
                      Aprobar
                    </button>
                  )}
                  {u.approved && (
                    <button
                      className="app-btn app-btn-quiet app-btn-sm"
                      onClick={() => handleSuspend(u._id || u.uid)}
                    >
                      Suspender
                    </button>
                  )}
                  <button
                    className="app-btn app-btn-danger app-btn-sm"
                    onClick={() => handleDelete(u._id || u.uid)}
                  >
                    Eliminar
                  </button>
                </>
              )}
            </div>
          </article>
        );
      })}
    </div>
  );
}

export default UserManager;
